import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {OauthService} from '../../shared/services/oauth.service';
import {CoreModule} from '../../core/core.module';
import {BlogArticleListPage} from './blog-article-list';
import {LocalStorageService} from '../../shared/services/localStorage.service';
import {BlogArticleService} from '../../shared/services/blogArticle.service';

@NgModule({
    declarations: [
        BlogArticleListPage,
    ],
    imports: [
        IonicPageModule.forChild(BlogArticleListPage),
        CoreModule,
    ],
    providers: [
        OauthService,
        BlogArticleService,
        LocalStorageService
    ]
})
export class BlogArticleListPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/blog-article-list/blog-article-list.module.ts